/**
 * Канал «нажат service-таб» от виджета нижней навигации к активному iframe.
 * Таб-бар сервиса рисует оболочка (по `ui.setTabBar`), а клик надо вернуть сервису
 * событием `tabBar.pressed`. Виджет и `IframeBridge` живут в разных местах дерева, поэтому
 * связываем их через модуль-синглтон: активный `IframeBridge` регистрирует обработчик,
 * виджет дёргает `pressServiceTab(id)`.
 */
let pressHandler: ((id: string) => void) | null = null;

export function setTabBarPressHandler(
  handler: ((id: string) => void) | null
): void {
  pressHandler = handler;
}

export function pressServiceTab(id: string): void {
  pressHandler?.(id);
}
